import dynamicAPI from './dynamicAPI'
import { useQuery, useMutation, useQueryClient } from 'react-query'

const url = '/api/auth/user-roles'

const queryKey = 'userRoles'

const useUserRolesHook = (props) => {
  const { page = 1, q = '', limit = 25 } = props
  const queryClient = useQueryClient()

  const getUserRoles = useQuery(
    queryKey,
    async () =>
      await dynamicAPI('get', `${url}?page=${page}&q=${q}&limit=${limit}`, {}),
    { retry: 0 }
  )

  const postUserRoleById = useMutation(
    async (id) => await dynamicAPI('post', `${url}/${id}`, {}),
    { retry: 0 }
  )

  const updateUserRole = useMutation(
    async (obj) => await dynamicAPI('put', `${url}/${obj._id}`, obj),
    {
      retry: 0,
      onSuccess: () => queryClient.invalidateQueries([queryKey]),
    }
  )

  const deleteUserRole = useMutation(
    async (id) => await dynamicAPI('delete', `${url}/${id}`, {}),
    {
      retry: 0,
      onSuccess: () => queryClient.invalidateQueries([queryKey]),
    }
  )

  const postUserRole = useMutation(
    async (obj) => await dynamicAPI('post', url, obj),
    {
      retry: 0,
      onSuccess: () => queryClient.invalidateQueries([queryKey]),
    }
  )

  return {
    getUserRoles,
    updateUserRole,
    deleteUserRole,
    postUserRole,
    postUserRoleById,
  }
}

export default useUserRolesHook
